module.exports = __webpack_public_path__ + "static/img/icon-back.6a3a2dff.svg";